export default function({ state, rootState, commit, dispatch }, id) {
    commit('startLoadingOverview')

    return dispatch('get', {
        url: '/provider/' + (id || state.id) + '/overview'
    }, {
        root: true
    })
    .then((overview) => {
        commit('finishLoadingOverview')
        commit('setProviderOverview', overview)
        commit('setProviderOverviewSite', overview.site)
        commit('setAllPatientCount', overview.all_patient_count)
        return overview
    })
    .catch((error) => {
        commit('finishLoadingOverview')
        console.log(error)
        throw error
    })
}
